import React from 'react';
import { ThemeProvider } from '@material-ui/core';

import theme from './index';

export default (el: React.ReactNode): React.ReactNode => (
  <ThemeProvider theme={theme}>{el}</ThemeProvider>
);
